import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import '../styles/attachmentRequirement.css';

/**
 * "Make private" — the assigner's switch.
 *
 * A private task is visible only to its assignees and whoever assigned it; not
 * Admin, HR or Team Leads. Enforced server-side (utils/taskScoping.js), so this
 * is the control, not the guarantee. Shares AttachmentRequirement's styling so
 * the two switches on the form read as a pair.
 */
const PrivateTaskToggle = ({ value, onChange, disabled = false }) => (
    <button
        type="button"
        className={`atr-toggle ${value ? 'is-on' : ''}`}
        onClick={() => onChange(!value)}
        disabled={disabled}
        aria-pressed={value}
    >
        <span className="atr-icon">
            <FontAwesomeIcon icon={value ? faLock : faLockOpen} />
        </span>

        <span className="atr-text">
            <span className="atr-label">Make private</span>
            <span className="atr-hint">
                {value
                    ? 'Only the assignees and you can see this task — not Admin, HR or Team Leads.'
                    : 'Visible to the usual managers, Admin and HR.'}
            </span>
        </span>

        <span className="atr-switch" aria-hidden="true"><span className="atr-knob" /></span>
    </button>
);

export default PrivateTaskToggle;
